import { useState } from "react";
import { TextField, Button, Container, Typography } from "@mui/material";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");

  const handleReset = () => {
    alert(`Password reset link sent to ${email}`);
  };

  return (
    <Container maxWidth="xs">
      <Typography variant="h5">Forgot Password</Typography>
      <TextField fullWidth label="Email" onChange={(e) => setEmail(e.target.value)} />
      <Button variant="contained" fullWidth onClick={handleReset}>Reset Password</Button>
    </Container>
  );
};

export default ForgotPasswordPage;
